import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { CircularProgress, ThemeProvider } from "@mui/material";

import { GuestRoutes, CustomerRoutes, ClientRoutes } from "@/routes";
import { Route } from "react-router-dom";
import { usePlatformSetup } from "@/hooks/platform/use-platform-setup.js";
import NotFound from "@/pages/not-found/not-found.jsx";
import InvoiceSlideIn from "@/components/invoices/invoice-slide-in.jsx";
import QuickPayViewDrawerWrapper from "@/components/invoices/quickpay-view-drawer-wrapper.jsx";
import ContactDrawer from "@/components/contact/contact-drawer.jsx";
import BillDrawer from "@/components/bill/bill-drawer.jsx";
import { Toaster } from "@/components/ui/toaster.jsx";
import CheckDepositDrawer from "@/components/invoices/check-deposit-drawer.jsx";
import RefundDrawer from "@/components/invoices/refund-drawer.jsx";
import CheckDepositConfirm from "@/components/invoices/check-deposit-confirm.jsx";
import CheckDepositExpired from "@/components/invoices/check-deposit-expired.jsx";
import { hasPermission } from "@/utils/auth.js";
import TransactionDrawer from "@/components/transactions/transaction-drawer.jsx";
import { useAuth } from "@/providers/auth.js";

import { MainLoadingWrapper } from "@/pages/styled.js";
import "react-toastify/dist/ReactToastify.min.css";
import "./App.css";

const App = () => {
  const { theme, error, isLoading } = usePlatformSetup();
  const { user } = useAuth();

  if (isLoading && error?.response?.status !== 404) {
    return (
      <MainLoadingWrapper>
        <CircularProgress disableShrink />
      </MainLoadingWrapper>
    );
  }

  return (
    <div style={{ height: "100vh", backgroundColor: "#f8f8f8" }}>
      <Router>
        <ThemeProvider theme={theme}>
          <Toaster />
          <ToastContainer
            hideProgressBar
            position="top-right"
            autoClose={5000}
          />
          <InvoiceSlideIn />
          <QuickPayViewDrawerWrapper />
          <ContactDrawer />
          <TransactionDrawer />
          <BillDrawer />
          <CheckDepositDrawer />
          <CheckDepositConfirm />
          <CheckDepositExpired />
          <RefundDrawer />

          {error?.response?.status === 404 ? (
            <Route path="*" component={NotFound} />
          ) : (
            <>
              {hasPermission(user, "guestRoutes", "view") && <GuestRoutes />}
              {hasPermission(user, "clientRoutes", "view") && <ClientRoutes />}
              {hasPermission(user, "customerRoutes", "view") && (
                <CustomerRoutes />
              )}
            </>
          )}
        </ThemeProvider>
      </Router>
    </div>
  );
};

export default App;
